import { I18N_CONFIG } from '@dovydaskukalis/shared/locales/config';
import * as enTranslations from '@dovydaskukalis/shared/locales/en/index';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// Import centralized config and English translations (tree-shaken by Vite)

export async function initI18n(): Promise<void> {
  await i18next
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: I18N_CONFIG.fallbackLanguage,
      ns: [...I18N_CONFIG.namespaces],
      defaultNS: I18N_CONFIG.defaultNamespace,

      // Bundle all English namespaces (tree-shaken)
      resources: {
        [I18N_CONFIG.defaultLanguage]: enTranslations,
      },

      // Lazy load other languages (JSON, Brotli compressed, HTTP cached)
      backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
      },

      // Only fetch from backend for non-English languages
      partialBundledLanguages: true,

      interpolation: {
        escapeValue: false, // React already escapes
      },

      react: {
        useSuspense: true, // Use React Suspense for loading states
      },
    });
}
